import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../utils/apiClient';
import {
    Container,
    Typography,
    Box,
    TextField,
    Button,
    Grid,
} from '@mui/material';

function SessionForm() {
    const { sessionId } = useParams();
    const id = sessionId;
    const navigate = useNavigate();
    const [session, setSession] = useState({
        title: '',
        description: '',
        duration: 120,
        thumbnail: '',
        materiel: '',
    });

    useEffect(() => {
        if (id) {
            const fetchSession = async () => {
                try {
                    const response = await apiClient.get('/sessions');
                    // Chercher la session par ID dans la liste
                    const found = Array.isArray(response.data)
                        ? response.data.find(s => String(s.id) === String(id))
                        : response.data?.sessions?.find(s => String(s.id) === String(id));
                    if (found) setSession(found);
                } catch (error) {
                    console.error('Erreur lors de la récupération de la session:', error);
                }
            };
            fetchSession();
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSession(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (id) {
                await apiClient.put(`/sessions/${id}`, session);
            } else {
                await apiClient.post('/sessions', session);
            }
            navigate('/');
        } catch (error) {
            console.error('Erreur lors de la sauvegarde de la session:', error);
        }
    };

    return (
        <Container maxWidth="md">
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    {id ? 'Modifier la session' : 'Nouvelle session'}
                </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                    <Grid item xs={12} style={{ width: "100%" }}>
                        <TextField
                            fullWidth
                            label="Titre de la session"
                            name="title"
                            value={session.title}
                            onChange={handleChange}
                            required
                        />
                    </Grid>

                    <Grid item xs={12} style={{ width: "100%" }}>
                        <TextField
                            fullWidth
                            label="Description"
                            name="description"
                            value={session.description}
                            onChange={handleChange}
                            multiline
                            rows={3}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Durée (secondes)"
                            name="duration"
                            type="number"
                            value={session.duration}
                            onChange={handleChange}
                            required
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="URL de la miniature"
                            name="thumbnail"
                            value={session.thumbnail}
                            onChange={handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} style={{ width: "100%" }}>
                        <TextField
                            fullWidth
                            label="Matériel nécessaire"
                            name="materiel"
                            value={session.materiel}
                            onChange={handleChange}
                            placeholder="Ex: une chaise, un tapis de yoga, des haltères..."
                            helperText="Décrivez le matériel nécessaire pour réaliser cette session"
                        />
                    </Grid>

                    <Grid item xs={12} style={{ width: "100%" }}>
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                            <Button
                                variant="outlined"
                                onClick={() => navigate('/')}
                            >
                                Annuler
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                {id ? 'Mettre à jour' : 'Créer la session'}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </form>
        </Container>
    );
}

export default SessionForm; 